module.exports = __webpack_public_path__ + "resources/img/img_tibero2_en.be354a66289caa26c669119dc8ec7171.png";